import { NgModule } from '@angular/core';
import { TranslateModule } from "@ngx-translate/core";
import { TmTeamSelectComponent } from "@teammood/team";
import { UserActivityComponent } from "./user-activity/user-activity.component";
import { EmptyTimelineComponent } from "./empty-timeline/empty-timeline.component";
import { UserRequestsComponent } from "./user-requests/user-requests.component";
import { DailyOverviewComponent } from "./daily-overview/daily-overview.component";
import { InfiniteScrollDirective } from "../shared/ui/infinite-scroll/infinite-scroll.directive";
import { TimelineComponent } from './timeline.component';
import { MatMenuModule } from '@angular/material/menu';

@NgModule({
  declarations: [
    TimelineComponent
  ],
    imports: [
        TranslateModule,
        TmTeamSelectComponent,
        UserActivityComponent,
        EmptyTimelineComponent,
        UserRequestsComponent,
        DailyOverviewComponent,
        InfiniteScrollDirective,
        MatMenuModule
    ]
})
export class TmTimelineModule{
}